import { Tab, Role } from '../const';

/**
 * @function makePostRoles
 * @param { array } roles
 * @param { string } id
 * @returns { Array }
 */
export function makePostRoles(roles, groupId) {
	let newRoles = [];

	if (roles.length === 0) {
		const tempRoles = [
			{ [Role.Id]: -2, [Role.Name]: '', [Role.Desc]: '', [Role.Type]: '', [Role.GroupId]: groupId },
		];
		newRoles = [...tempRoles];
	} else {
		newRoles = [...roles];
	}
	return newRoles;
}

/**
 * @function makePostSubtabs
 * @param { array } subtabs
 * @param { string } groupId
 * @param { string } subtabId
 * @returns { array }
 */
export function makePostSubtabs(subtabs, groupId, subtabId) {
	let newSubtabs = null;

	if (subtabs.length === 0) {
		const emptySubtabs = [
			{
				[Tab.GroupId]: groupId,
				[Tab.Id]: '-2',
				[Tab.Name]: '',
				[Tab.Url]: '',
				[Tab.Desc]: '',
				[Tab.Order]: '',
				[Tab.SubtabId]: subtabId,
				[Tab.Checked]: false,
			},
		];
		newSubtabs = [...emptySubtabs];
	} else {
		newSubtabs = [...subtabs];
	}

	return newSubtabs;
}
